import useMutationApi from 'src/api/useMutationApi';

export interface UpdateUserRequest {
  name?: string;
  email?: string;
  isAdmin?: boolean;
}

export interface UpdateUserResponse {
  userId: string;
  name: string;
  email: string;
}

const useUpdateUser = (userId: string) => {
  return useMutationApi<UpdateUserRequest, UpdateUserResponse>({
    endpoint: `organization/members/${userId}`,
    method: 'PUT',
  });
};

export default useUpdateUser;
